import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import CKEditor from '@ckeditor/ckeditor5-react'
import CKEditorInline from '@ckeditor/ckeditor5-build-inline'
import { Modal, Button, Input, Icon, Popconfirm } from 'antd'

@inject((store: any) => {
    const { popupStore, termsStore } = store
    return { popupStore, termsStore }
})
@observer
export default class EditTermPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    validateTerm = () => {
        const { editTerm } = this.props.termsStore
        if (!editTerm.title) {
            this.setError('titleError', 'לא ניתן לשמור תנאי ללא כותרת')
            return false
        } else if (!editTerm.description || editTerm.description === '<p>&nbsp;</p>') {
            this.setError('descriptionError', '* לא ניתן לשמור תנאי ללא תיאור')
            return false
        }
        return true
    }

    setError = (name, msg) => {
        this.setState({ errors: { [name]: msg } })
    }

    handleUpdate = async () => {
        const { collection_id } = this.props.popupStore.info
        if (this.validateTerm()) {
            this.resetErrors()
            try {
                await this.props.termsStore.updateTerm(collection_id)
                this.props.popupStore.togglePopup(false)
            } catch (e) {
                this.setError('serverError', 'קיימת שגיאה בחיבור לשרת')
            }
        }
    }

    resetErrors = () => {
        this.setState({ errors: {} })
    }

    closePopup = () => {
        this.props.termsStore.setEditTerm(this.props.popupStore.info)
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { errors } = this.state
        const { popupStore } = this.props
        const { loading, editTerm, changeValue } = this.props.termsStore
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
                <Popconfirm
                    title="האם ברצונך לשמור את השינויים?"
                    okText="אישור"
                    cancelText="ביטול"
                    onConfirm={() => this.handleUpdate()}
                >
                    <Button type="primary" disabled={loading}>
                        {loading ? <Icon type="loading" /> : ''}
                        שמור שינויים
                    </Button>
                </Popconfirm>
            </div>
        )
        return (
            <Modal
                title={`עריכת תנאי`}
                visible={popupStore.popupType === 'editTerm'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1100}
            >
                <div
                    style={{
                        fontWeight: 'bold',
                        backgroundColor: '#a53030',
                        color: 'white',
                        padding: '0.5rem',
                        marginBottom: '0.5rem'
                    }}
                >
                    לתשומת ליבך! עריכת התנאי תשנה את הערכים בכל הזכויות שהתנאי מקושר אליהן
                </div>
                {errors.serverError ? (
                    <div
                        style={{
                            fontWeight: 'bold',
                            backgroundColor: '#a53030',
                            color: 'white',
                            padding: '0.5rem',
                            marginBottom: '0.5rem'
                        }}
                    >
                        {errors.serverError}
                    </div>
                ) : (
                    ''
                )}

                <label style={{ fontSize: '1rem' }}>
                    <strong>כותרת התנאי</strong>
                </label>
                <Input
                    value={editTerm.title}
                    onChange={e => changeValue('title', e.target.value)}
                    placeholder="הזן כותרת"
                />
                {errors.titleError ? <div style={{ color: 'red' }}>{errors.titleError}</div> : ''}
                <label style={{ fontSize: '1rem' }}>
                    <strong>תיאור התנאי</strong>
                </label>
                <div style={{ border: '1px solid #d4d4d4', borderRadius: '5px' }}>
                    <CKEditor
                        data={editTerm.description}
                        editor={CKEditorInline}
                        onChange={(event, editor) => {
                            const data = editor.getData()
                            changeValue('description', data)
                        }}
                        config={{
                            language: 'he',
                            toolbar: [
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'blockQuote',
                                'insertTable',
                                'undo',
                                'redo'
                            ]
                        }}
                    />
                </div>
                {errors.descriptionError ? <div style={{ color: 'red' }}>{errors.descriptionError}</div> : ''}
                <label style={{ marginTop: '1rem', fontSize: '1rem' }}>
                    <strong>הוראות למימוש התנאי</strong>
                </label>
                <div style={{ border: '1px solid #d4d4d4', borderRadius: '5px' }}>
                    <CKEditor
                        data={editTerm.instruction}
                        editor={CKEditorInline}
                        onChange={(event, editor) => {
                            const data = editor.getData()
                            changeValue('instruction', data)
                        }}
                        config={{
                            language: 'he',
                            toolbar: [
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'blockQuote',
                                'insertTable',
                                'undo',
                                'redo'
                            ]
                        }}
                    />
                </div>
            </Modal>
        )
    }
}
